import { createDefaultRecipientRoleFieldBase } from './default-recipient-role-field';
import { Field } from './fields';
import { FieldEnum, FieldTypeEnum, SelectedFieldEnum } from './fields.dto'

const withCalculation = (field: Field) => ({
  connected_parent_calculation_id: field.connected_parent_calculation_id ?? [],
});

export const DroplistField = {
    tag(field) {
        return {
            ...createDefaultRecipientRoleFieldBase(field, true),
            field_name: "Droplist",
            field: FieldEnum.DroplistField,
            type: FieldTypeEnum.Droplist,
            selected_field: SelectedFieldEnum.DroplistField,
            multi_select: field.multi_select ?? 0,
            options: field.options ?? [],
            selected_option_id: field.selected_option_id ?? 0,
            column: field.column ?? "50",
            ...withCalculation(field)
        }
    }
}